import API from 'services/TAPS_API/index';

export default function getCameralAudit(year = 2016) {
  return API.request({
    method: 'GET',
    url: `/notification/1151020/cameral/${year}`,
  });
}
